export default __webpack_public_path__ + "static/media/comfort3.5b83c6e3.jpg";